import { NotificationService } from '@cradua/core';
import { Injectable } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { map, catchError, concatMap, exhaustMap } from 'rxjs/operators';
import { of } from 'rxjs';
import * as ScholarshipAwardDurationActions from './scholarshipawardduration.actions';
import { ScholarshipAwardDurationService } from '../../services/scholarshipawardduration.service';

@Injectable()
export class ScholarshipAwardDurationEffects {
  loadScholarshipAwardDuration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipAwardDurationActions.loadScholarshipAwardDuration),
      exhaustMap((_) =>
        this.scholarshipAwardDurationService.getScholarshipAwardDuration().pipe(
          map((data) =>
            ScholarshipAwardDurationActions.loadScholarshipAwardDurationSuccess(
              {
                scholarshipAwardDuration: data,
              }
            )
          ),
          catchError((error) =>
            of(
              ScholarshipAwardDurationActions.loadScholarshipAwardDurationFailure(
                { error }
              )
            )
          )
        )
      )
    )
  );

  addScholarshipAwardDuration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipAwardDurationActions.addScholarshipAwardDuration),
      concatMap(({ newScholarshipAwardDuration }) =>
        this.scholarshipAwardDurationService
          .createScholarshipAwardDuration(newScholarshipAwardDuration)
          .pipe(
            map((data) => {
              this.notification.success('Saved Successfully');
              return ScholarshipAwardDurationActions.addScholarshipAwardDurationSuccess(
                {
                  newScholarshipAwardDuration: data,
                }
              );
            }),
            catchError((error) =>
              of(
                ScholarshipAwardDurationActions.addScholarshipAwardDurationFailure(
                  {
                    error: error.error.message,
                  }
                )
              )
            )
          )
      )
    )
  );

  updateScholarshipAwardDuration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipAwardDurationActions.updateScholarshipAwardDuration),
      map((action) => action.updateScholarshipAwardDuration),
      concatMap((updateScholarshipAwardDuration) =>
        this.scholarshipAwardDurationService
          .updateScholarshipAwardDuration(updateScholarshipAwardDuration)
          .pipe(
            map((_) => {
              this.notification.success('Updated Successfully');
              return ScholarshipAwardDurationActions.updateScholarshipAwardDurationSuccess(
                {
                  updateScholarshipAwardDuration: updateScholarshipAwardDuration,
                }
              );
            }),
            catchError((error) =>
              of(
                ScholarshipAwardDurationActions.updateScholarshipAwardDurationFailure(
                  {
                    error: error.message,
                  }
                )
              )
            )
          )
      )
    )
  );

  removeScholarshipAwardDuration$ = createEffect(() =>
    this.actions$.pipe(
      ofType(ScholarshipAwardDurationActions.removeScholarshipAwardDuration),
      map((action) => action.ids),
      concatMap((ids) =>
        this.scholarshipAwardDurationService
          .deleteScholarshipAwardDuration(ids)
          .pipe(
            map(() => {
              this.notification.success('Deleted Successfully');
              return ScholarshipAwardDurationActions.removeScholarshipAwardDurationSuccess(
                { ids }
              );
            }),
            catchError((error) =>
              of(
                ScholarshipAwardDurationActions.updateScholarshipAwardDurationFailure(
                  {
                    error: error.message,
                  }
                )
              )
            )
          )
      )
    )
  );

  constructor(
    private actions$: Actions,
    private scholarshipAwardDurationService: ScholarshipAwardDurationService,
    private notification: NotificationService
  ) {}
}
